import { Component, type ReactNode } from 'react'
import Alert from '@cloudscape-design/components/alert'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <Alert type="error" header="An error occurred">
          {this.state.error.message}
        </Alert>
      )
    }

    return this.props.children
  }
}
